export default __webpack_public_path__ + "img/youtube_hover.fe664f9320d01acea3a5aa3e42206f8b.svg";